import { KEYWORD_OPTIONS, ROUTE_PATH, TEMPLATE_OPTIONS } from 'common/constants/sm-constants';
import { GridMetaModel, Headers } from 'common/models/utility-models/meta-model';

export class EmailTemplateGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Email Template',
            ROUTE_PATH.templateGrid,
            ROUTE_PATH.addTemplate,
            true,
            true,
            8,
            false,
            true,
            ['name'],
            false,

            [],
            {
                isDownloadExcel: false, excelFileName: '',
                btnLabel: '', headers: []
            },
            false,
            null,
            false,
            false,
            true,
            null,
            { evalKey: 'wantToDelete', evalParam: [1], decisiveParam: false },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: '',
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false,
            },
            true,
            true,
            false,
            [],
            true,
            {
                isExtraActions: false, btnLabel: '',
            },
            {
                isCheckboxEmit: false,
                emitKey: 'id',
                checkedKey: '',
                valueKey: '',
              }, // checkboxEmitIds
              {
                isDownload: false,
                key: '',
                valueKey: '',
              }, // downloadDetails
              {
                isTabStatus: false,
                label: '',
                isChecked: false,
              }, // statusActions
              false, // totalEntry
              true, // showDeleteButton
              {
                isPrimary: true,
                isDanger: false,
              }, // deleteButtonCss
              '', // totalTag
              { value: '', isVisible: false }, // subHeader
              false, // noPlaceHolderRequired
              false, // changeDeleteAllPayload
              true, // isHighlight
              {
                isExtraActions: false,
                btnLabel: '',
                selectOptions: [],
                selectedValue: '',
                isPreviewBtn: false,
                previewBtnLabel: '',
              }, // extraRowAction
              { value: 'Add Template', isVisible: true },





        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const name = new Headers('Email Template Name', 'name', false, true, 'text');
        const subject = new Headers('Email Template Subject', 'subject', false, true, 'text');
        const view = new Headers('View', 'view', false, false, 'view')
        headers.push(name);
        headers.push(subject);
        headers.push(view);

        return headers;
    }
}   